import React from 'react';
import { compose, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getTranslate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import Loader from '@/components/Loader';
import * as actions from '@/store/actions';
import { selectCompanyLicenses } from '@/store/reducers/licenses';
import Licenses from './Licenses';
import { TrialType, ListState, LicenseType, LicensesInformation, License } from '@/types';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ApplicationState } from '@/store';

interface OwnProps {
    suggestedTrialType?: TrialType;
    suggestedLicenseId?: number;
    currentTrialPeriod?: any;
    suggestedLicense?: any;
    onContinueTrial?: () => void;
    onSubmitSuccess?: () => void;
    onUpgradeLicence?: () => void;
    onSelectPlan?: () => void;
    onGoBack?: () => void;
    autofill?: boolean
}

interface Props extends OwnProps, LocalizeContextProps, RouteComponentProps {
    dispatch: Dispatch;
    companyLicenses: ListState<License>;
    types: ListState<LicenseType>;
    licenseInformationTypes: ListState<any>
    licensePlans: ListState<any>;
    information: ListState<LicensesInformation>;
    billing: ApplicationState['billing'];
    addTrial: any;
    modal: any;
}

const LicensesLoader: React.FC<Props> = (props) => {
    return (
        <Loader
            // Plan tabs live in the URL hash; switching tabs must not refetch everything.
            reloadOnHashChange={false}
            requirements={
                props.suggestedTrialType
                    ? []
                    : [
                          {
                              action: actions.FETCH_LICENSE_TYPES.request({
                                  ExtraLicenseOption: false,
                              }),
                              data: props.types,
                          },
                          {
                              action: actions.FETCH_LICENSE_INFO.request(),
                              data: props.information,
                          },
                          {
                              action: actions.FETCH_COMPANY_LICENSES.request({
                                  IncludeVossSubscription: true,
                              }),
                              data: props.companyLicenses,
                          },
                          {
                              action: actions.FETCH_LICENSE_INFORMATION_TYPES.request(),
                              data: props.licenseInformationTypes,
                          },
                          {
                              action: actions.FETCH_LICENSE_PLANS.request({ Active: true }),
                              data: props.licensePlans,
                          },
                          {
                              action: actions.FETCH_BILLING_SETTINGS.request(),
                              data: props.billing.settings,
                          },
                      ]
            }
        >
            <Licenses {...props} />
        </Loader>
    );
};

const mapStateToProps = (state: ApplicationState) => {
    const { billing } = state;
    const { information, types, creditCard, modal, addTrial, licenseInformationTypes, licensePlans } = state.licenses;

    return {
        addTrial,
        billing,
        information,
        licenseInformationTypes,
        licensePlans,
        modal,
        types,
        companyLicenses: selectCompanyLicenses(state),
        translate: getTranslate(state.localize),
    };
};

export default compose<React.ComponentType<OwnProps>>(
    connect(mapStateToProps),
    withRouter,
    withLocalize
)(LicensesLoader);
